import { Zone } from './Zone';
import { createTimeline } from '../Timeline';
import { ZoneConfiguration } from './types';

export function createZone(zoneConfiguration: ZoneConfiguration): Zone {
    const timeline = createTimeline(zoneConfiguration.type, {
        loopLength: zoneConfiguration.policy ?? 60,
        shuffle: zoneConfiguration.shuffle ?? false,
    });
    const zone = new Zone(zoneConfiguration, timeline);

    zone.initialize();

    return zone;
}
